import requests from 'api/requests';
import FilteredTable from 'components/FilteredTable';
import { IStatus } from 'pages/settings/statuses/base/types';
import { useEffect, useRef, useState } from 'react';
import { useHistory, useLocation, useRouteMatch } from 'react-router-dom';
import columns from './columns';
import filters from './filters';
import InstanceModal from './instanceModal';
import { IDriverRequest, IExtendData } from './types';
import NeedDriverControl from './needDriverControl';
import queryString from 'query-string';



export default function DriverRequest() {
  const { hash } = useLocation();
  let history = useHistory();
  const tableRef = useRef(null)
  const [instance, setInstance] = useState<null | IDriverRequest>(null);
  const [extendData, setExtendData] = useState<IExtendData | undefined>(undefined);

  const match: any = useRouteMatch();
  const atp = match.params.id;

  useEffect(() => {
    Promise.all([
      requests.get('/settings/statuses/driver-request/').then((r) => r.body),
    ]).then((r) => {
      const _statuses = r[0];

      let _statusDict = {} as any;
      _statuses.map((status: IStatus) => {
        if (status.id !== undefined) {
          _statusDict[status.id] = status;
        }
        return status;
      })

      setExtendData({
        statuses: _statuses,
        statusDict: _statusDict,
      })
    })
  }, [])

  useEffect(() => {
    const parsed = queryString.parse(hash);
    if (!parsed.instance){
      setInstance(null)
      return;
    };

    requests.get(`/atp/driver/request/${parsed.instance}/`, {
      atp_id: atp
    }).then((r) => {
      setInstance(r.body)
    }).catch(() => {
      setInstance(null)
    })
  }, [hash, atp])

  if (!extendData) return null;

  return (
    <div>
      <FilteredTable
        dataURL="/atp/driver/request/"
        columns={columns}
        filters={filters}
        defaultFilters={{ atp_id: atp }}
        userSettingsKey="apt-driver-requests"
        onRowClick={(i)=>{
          history.push(`#instance=${i.id}`);
        }}
        extendData={extendData}
        tableRef={tableRef}
        smallPadding
        leftSide={(
          <NeedDriverControl
            atpID={atp}
            onChanged={()=>{
              (tableRef.current as any).reload();
            }}
          />
        )}
      />
      {instance !== null ? (
        <InstanceModal
          instance={instance}
          onClose={() => {
            history.push(`#`);
          }}
          onStatusChange={() => {
            (tableRef.current as any).reload();
          }}
        />
      ) : null}
    </div>
  )
}